import { ADMIN_USER_TYPE } from "constants/index";
import { AuthorizedUser } from "models/auth";
import { Navigate } from "react-router-dom";

const ProtectedRoute = (props: { user: AuthorizedUser; children: JSX.Element }) => {
  const { user, children } = props;
  const isAdmin = user.user.bytType === ADMIN_USER_TYPE;

  if (!isAdmin) {
    return <Navigate to={"/unauthorized"} replace />;
  } else {
    return children;
  }
};

export default ProtectedRoute;
